import { sendEvent } from "~/app/analytics/ga/ga";
import { getConfiguratorDefinition } from "~/bridges/configurator/configuratorRegistry";
import { makeSummaryDataProvider } from "~/features/configurator/Shaft/shaftGaHelper";
import { getStore } from "~/app/store/getStore";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function sendLCEvent(event: any) {
  sendEvent(event);
}

export type PushContextValues =
  | "click_on_reset"
  | "click_on_open"
  | "click_on_save"
  | "click_on_CAD_button"
  | "open_CAD_tab"
  | "request_offer";
export function trackLCSimpleClick(
  productCode: string,
  stepNumber: number,
  pushContext: PushContextValues,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  extra?: Dict<any>,
) {
  const stepName = makeSummaryDataProvider(getStore().getState()).getGaStepName(stepNumber);
  if (!stepName) {
    return;
  }
  sendLCEvent({
    event: "linearConfigInteraction",
    variant: getGAConfiguratorVariant(productCode),
    step: stepName,
    push_context: pushContext,
    ...(extra ?? {}),
  });
}

export function trackLCPreviousClick(productCode: string, step: number, previousStepNumber: number) {
  sendLCEvent({
    event: "linearConfigInteraction",
    variant: getGAConfiguratorVariant(productCode),
    step: step + "_" + previousStepNumber,
    push_context: "click_on_previous_step",
  });
}

export function trackLCStepperClick(productCode: string, step: number, targetStepNumber: number) {
  sendLCEvent({
    event: "linearConfigInteraction",
    variant: getGAConfiguratorVariant(productCode),
    step: step + "_" + targetStepNumber,
    push_context: "click_on_stepper",
  });
}

export function getGAConfiguratorVariant(productCode: string) {
  return getConfiguratorDefinition(productCode).gaConfiguratorName;
}

interface SummaryGATrackingData {
  schaefflerId?: string;
  productName?: string;
}

export function trackLCSaveConfiguration(
  productCode: string,
  stepNumber: number,
  { schaefflerId, productName }: SummaryGATrackingData,
) {
  const stepName = makeSummaryDataProvider(getStore().getState()).getGaStepName(stepNumber + 1);
  if (!stepName) {
    return;
  }
  sendLCEvent({
    event: "linearConfigInteraction",
    variant: getGAConfiguratorVariant(productCode),
    step: stepName,
    push_context: `${(getGAConfiguratorVariant(productCode) ?? "").toLowerCase()}_configuration_saved`,
    selection_data: {
      configuration_saved: schaefflerId ?? undefined,
      final_name: productName ?? undefined,
    },
  });
}

export function trackLCAddToCart(
  productCode: string,
  stepNumber: number,
  { schaefflerId, productName }: SummaryGATrackingData,
) {
  const stepName = makeSummaryDataProvider(getStore().getState()).getGaStepName(stepNumber + 1);
  if (!stepName) {
    return;
  }
  sendLCEvent({
    event: "linearConfigInteraction",
    variant: getGAConfiguratorVariant(productCode),
    step: stepName,
    push_context: `${(getGAConfiguratorVariant(productCode) ?? "").toLowerCase()}_configuration_added to cart`,
    selection_data: {
      added_to_cart: schaefflerId ?? undefined,
      final_name: productName ?? undefined,
    },
  });
}

export function trackLCStepStarted(productCode: string, stepNumber: number) {
  const stepName = makeSummaryDataProvider(getStore().getState()).getGaStepName(stepNumber + 1);
  if (!stepName) {
    return;
  }
  sendLCEvent({
    event: "linearConfigInteraction",
    push_context: `step_started`,
    step: stepName,
    variant: getGAConfiguratorVariant(productCode),
  });
}
